import { render, staticRenderFns } from "./NotificationAlt.vue?vue&type=template&id=1d2f7eb6&"
import script from "./NotificationAlt.vue?vue&type=script&lang=ts&"
export * from "./NotificationAlt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports